import { render, staticRenderFns } from "./suporte.vue?vue&type=template&id=8c2290be&scoped=true&"
import script from "./suporte.vue?vue&type=script&lang=js&"
export * from "./suporte.vue?vue&type=script&lang=js&"
import style0 from "./suporte.vue?vue&type=style&index=0&id=8c2290be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c2290be",
  null
  
)

export default component.exports